import { QueryState } from 'src/app/core/models/query.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { IDataControllo } from './date-controllo.model';

export const DATECONTROLLO_ENDPOINT = 'date-controllo';
export const DATECONTROLLO_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(DATECONTROLLO_ENDPOINT);

export const dateControlloStateConfig: SignalStoreConfig<QueryState<IDataControllo>> = {
  initState: {
    list: [],
    sort: {
      field: 'dataControllo',
      direction: 'asc'
    }
  }
}
